import { useSearchParams } from "react-router-dom";

export const LINKED_FILTERS_PARAM_KEY = "isLinked";

export function useLinkedFilters(): boolean {
  const [searchParams] = useSearchParams();

  const linkedParamValue = searchParams.get(LINKED_FILTERS_PARAM_KEY);
  const isLinked = linkedParamValue === "true" ? true : false;

  return isLinked;
}
